import { createContext } from 'react';
const VideoContext = createContext({});
const VideoContextProvider = VideoContext.Provider;
const VideoContextConsumer = VideoContext.Consumer;
export { VideoContext, VideoContextProvider, VideoContextConsumer };
//# sourceMappingURL=VideoContext.js.map